/* eslint-disable @typescript-eslint/no-explicit-any */

import { i18n } from '@modernloop/i18n';

const NETWORK_ERROR = 'Network Error';
enum ErrorReason {
  NOT_ALL_REQUIRED_SCOPES_CONSENTED_BY_USER = 'NOT_ALL_REQUIRED_SCOPES_CONSENTED_BY_USER',
}

export const getErrorStatus = (error: any): number => {
  return error?.response?.status || error?.status || 0;
};

export const getErrorMessageForReason = (reason: ErrorReason, metadata: { [key: string]: string } = {}) => {
  const metadataStr = Object.keys(metadata)
    .map((key) => `${key}: ${metadata[key]}`)
    .join(', ');

  switch (reason) {
    case ErrorReason.NOT_ALL_REQUIRED_SCOPES_CONSENTED_BY_USER: {
      return i18n.t('common:shared.error.permissionNotGranted', { metadata: metadataStr });
    }
    default:
  }

  return i18n.t('common:shared.error.genericRetry');
};

export const getExternalErrorMessage = (error: any, tryAgain = true): string => {
  const status = getErrorStatus(error);
  const message = error?.response?.data?.error?.message || error?.response?.data?.message || error.message;

  // Likely a network error if it is an axios error and there is no response
  const isAxiosNetworkError = !!error.isAxiosError && !error.response;

  if (status === 502 || message === NETWORK_ERROR || isAxiosNetworkError) {
    return i18n.t('common:shared.error.networkError');
  }

  if (status >= 500) {
    return tryAgain ? i18n.t('common:shared.error.serverErrorRetry') : i18n.t('common:shared.error.serverErrorContact');
  }

  if (status === 412) {
    if (error?.response?.data?.message) {
      return error?.response?.data?.message;
    } // java
    if (error?.response?.data?.details?.length) {
      return getErrorMessageForReason(error.response.data.details[0].reason, error.response.data.details[0].metadata);
    }
  }

  // This error usually will happen when GRPC proto field validation fails.
  // Ideally should not happen, unless we are developing the feature or not doing enough FE validation.
  if (status === 400) {
    return i18n.t('common:shared.error.badRequest');
  }

  return message;
};

export const getInternalErrorMessage = (error: any): string => {
  return error?.response?.data?.error?.message || error?.response?.data?.message || error.message || '';
};

export const isPermissionsError = (error: any): boolean => {
  return getInternalErrorMessage(error).indexOf('permission') !== -1;
};
